import {Field} from 'formik';

import {
    FormikNumberInput,
    FormikRadioGroup,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Container} from "@mantine/core";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";
import {FormikList} from '../../../components/FormikList';
import {ProductsAutocomplete} from "../../products/inputs/ProductsAutocomplete.tsx";
import {PricesAutocomplete} from '../../prices/inputs/PricesAutocomplete.tsx';
import {SubscriptionStatus} from "../types.ts";


export const FormComponent = () => {


    return (
        <Container>
            <PlatformFieldset legend={'Subscription'}>

                <Field
                    name='customerId'
                    label='Customer'
                    description='Please enter customer'
                    component={CustomersAutocomplete}
                    my={'xl'}
                />


                <Field
                    name='items'
                    label='Subscription Items'
                    description='Please enter product'
                    component={FormikList}
                    getRowElements={() => [
                        {
                            name: 'productId',
                            placeholder: 'Product',
                            component: ProductsAutocomplete,
                            span: 5
                        },
                        {
                            name: 'priceId',
                            placeholder: 'Price',
                            component: PricesAutocomplete,
                            span: 5
                        },
                        {
                            name: 'quantity',
                            placeholder: 'Quantity',
                            component: FormikNumberInput,
                            span: 2
                        }]}
                    my={'xl'}
                />

                <Field
                    name='status'
                    label='Status'
                    description='Please enter subscription status'
                    component={FormikRadioGroup}
                    data={[
                        {
                            value: SubscriptionStatus.Active,
                            label: SubscriptionStatus.Active
                        },
                        {
                            value: SubscriptionStatus.Inactive,
                            label: SubscriptionStatus.Inactive
                        },
                    ]}
                    my={'xl'}
                />

            </PlatformFieldset>

        </Container>
    );
};
